import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

// Modal
import { ModalUserTypeService } from '../../components/modal-user-type/modal-user-type.service';

/**
 * Guard to not let the user to continue without signing up
 */
export const selectUserTypeGuard: CanActivateFn = () => {
  const modalUserTypeService = inject(ModalUserTypeService);
  const router = inject(Router);

  const userType = JSON.parse(localStorage.getItem('Type') ?? 'null');
  if (
    userType === 'teacher' ||
    userType === 'student' ||
    userType === 'parent'
  ) {
    modalUserTypeService.hideModal();
    return true;
  }

  modalUserTypeService.showModal();
  router.navigate(['/sign-in']);
  return false;
};
